import React, { FC } from 'react';

import { SidePanelFooterProps } from './SidePanel.types';
import cx from 'classnames';
import './sidepanel.scss';

export const SidePanelFooter: FC<SidePanelFooterProps> = ({
	className = "",
	children,
	style = {},
}) => {
	return (
		<div 
			className={cx("gtc-rc-side-panel-footer", className)} 
			style={style}
		>
			{children}
		</div>
	)
};